export default "__VITE_ASSET__DcJHsp9V__"